import React from "react";
import SideNav from "./SideNav";
import Header from "./Header";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSidebar } from "./SidebarProvider";


function Layout({ children }) {
  const { isSidebarOpen } = useSidebar();
  const location = useLocation();
  const { pathWithoutLayout } = useSelector((state) => state.auth);

  if (pathWithoutLayout.includes(location.pathname)) {
    return <main>{children}</main>;
  }

  return (
    <div className="app-layout">
      <div>
        <SideNav  />
      </div>
      <div className="main-content"
        style={{
          width: isSidebarOpen ? "calc(100% - 225px)" : "calc(100% - 70px)",
        }}
      >
        <Header isOpen={isSidebarOpen} />
        <div className="page-content">{children}</div>
      </div>
    </div>
  );
}

export default Layout;
